import React from 'react';
import { graphql } from 'gatsby';

import LayoutEmbed from '~/components/layout/embed';
import Seo from '~/components/util/seo';
import ProductCard from '~/components/modules/cards/products/item';

const EmbededItem = ({ data }) => {
	const item = data.Item;
	return (
		<LayoutEmbed>
			<Seo title={item.data.Name} description="" />
			<ProductCard key={item.recordId} product={item} embedMode={true} />
		</LayoutEmbed>
	);
};

export const query = graphql`
	query EmbedItemPageQuery($recordId: String!) {
		Item: airtableItems(recordId: { eq: $recordId }) {
			recordId
			data {
				Name
				Status
				Description
				Last_Modified
				Sites {
					data {
						Name
					}
				}
				Availability {
					recordId
					data {
						SKU
						Availability
						Filesize
						Orderable
						Limit
						Status
						Payload
					}
				}
				Item_Type {
					data {
						Name
					}
				}
				Category {
					data {
						Name
					}
				}
				Size {
					data {
						Name
					}
				}
				File_Type {
					data {
						Name
					}
				}
				Groups {
					data {
						Name
					}
				}
				Vendor {
					data {
						Name
					}
				}
				Thumbnail {
					localFiles {
						childImageSharp {
							gatsbyImageData
						}
					}
				}
				Toolkits {
					data {
						Name
						Slug
						Sites {
							data {
								Name
							}
						}
					}
				}
				Audiences {
					data {
						Name
					}
				}
				End_Users {
					data {
						Name
					}
				}
			}
		}
	}
`;

export default EmbededItem;
